import { render, staticRenderFns } from "./ele15.vue?vue&type=template&id=01479b2f&scoped=true"
import script from "./ele15.vue?vue&type=script&lang=js"
export * from "./ele15.vue?vue&type=script&lang=js"
import style0 from "./ele15.vue?vue&type=style&index=0&id=01479b2f&prod&lang=scss"
import style1 from "./ele15.vue?vue&type=style&index=1&id=01479b2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01479b2f",
  null
  
)

export default component.exports